<template>
    <div class="container">
        <b-modal
            :model-value="showDialog"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.newTasaCamb"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog create-tasa-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <!-- Campo: Vigencia -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.validity }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="form.validity"
                            type="month"
                            class="form-input"
                            placeholder="AAAA-MM"
                        />
                    </b-col>
                </b-row>

                <!-- Campo: Moneda -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.currency }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="form.idCurrency"
                            class="form-input"
                        >
                            <template #first>
                                <b-form-select-option value="" disabled>
                                    -- {{ labels.selectCurrency }} --
                                </b-form-select-option>
                            </template>
                            <option 
                                :key="currency?.id" 
                                :value="currency?.id" 
                                v-for="currency in listCurrency"
                            >
                                {{ currency?.nombre }}
                            </option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Campo: Tasa Cierre -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.closingRate }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="form.closingRate"
                            type="number"
                            step="0.0001"
                            class="form-input"
                            placeholder="Tasa de cierre"
                        />
                    </b-col>
                </b-row>

                <!-- Campo: Tasa Promedio -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.averageRate }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="form.averageRate"
                            type="number"
                            step="0.0001"
                            class="form-input"
                            placeholder="Tasa promedio"
                        />
                    </b-col>
                </b-row>

                <!-- Campo: Tasa Interna -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.internalRate }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="form.internalRate"
                            type="number"
                            step="0.0001"
                            class="form-input"
                            placeholder="Tasa interna"
                        />
                    </b-col>
                </b-row>

                <!-- Botones de acción -->
                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="mr-2 reset-btn-secondary" @click="clicked">{{ labels.close }}</b-button>
                    <b-button class="reset-btn-primary" @click="saveTasaCamb" :disabled="isLoading">
                        <b-spinner v-if="isLoading" small class="mr-1"></b-spinner>
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import TasaCambio from "@/services/TasaCambio"
import Currency from "@/services/Currency"

export default {
    name: "NewTasaCambio",
    props: ['showDialog'],
    data: () => ({
        form: {
            validity: "",
            idCurrency: "",
            closingRate: "",
            averageRate: "",
            internalRate: "",
        },
        listCurrency: [],
        isLoading: false,
        validityAnterior: "",
    }),
    computed: {
        isVigenciaBloqueada() {
            return this.form.validity
                ? !this.$store.getters.isPeriodoEnabled(this.form.validity)
                : false
        },
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    newTasaCamb: "Nueva Tasa de Cambio",
                    validity: "Vigencia",
                    currency: "Moneda",
                    selectCurrency: "Seleccione una moneda",
                    closingRate: "Tasa Cierre",
                    averageRate: "Tasa Promedio",
                    internalRate: "Tasa Interna",
                    save: "Guardar",
                    close: "Cerrar",
                    infoTitle: "Nueva tasa de cambio",
                    infoText: "Completa la información para registrar una nueva tasa de cambio."
                }
            } else {
                return {
                    newTasaCamb: "New Exchange Rate",
                    validity: "Validity",
                    currency: "Currency",
                    selectCurrency: "Select a currency",
                    closingRate: "Closing Rate",
                    averageRate: "Average Rate",
                    internalRate: "Internal Rate",
                    save: "Save",
                    close: "Close",
                    infoTitle: "New exchange rate",
                    infoText: "Complete the information to register a new exchange rate."
                }
            }
        }
    },
    watch: {
        showDialog(val) {
            if (val) {
                this.resetForm()
            }
        },
        'form.validity'(valNew) {
            if (valNew !== this.validityAnterior) {
                this.validityAnterior = valNew
                if (this.isVigenciaBloqueada) {
                    this.$toast.error("La vigencia seleccionada está deshabilitada para crear o editar")
                }
            }
        }
    },
    methods: {
        resetForm() {
            this.form = {
                validity: "",
                idCurrency: "",
                closingRate: "",
                averageRate: "",
                internalRate: "",
            }
            this.validityAnterior = ""
        },
        clicked() {
            this.$emit('clicked', false)
        },
        saveTasaCamb() {
            if (this.isVigenciaBloqueada) {
                this.$toast.error("La vigencia seleccionada está deshabilitada para crear o editar")
                return
            }
            if (this.form.validity == "") {
                this.$toast.error("Diligenciar el campo Vigencia")
                return
            }
            if (this.form.idCurrency == "") {
                this.$toast.error("Seleccionar una moneda")
                return
            }
            if (this.form.closingRate == "") {
                this.$toast.error("Diligenciar el campo Tasa Cierre")
                return
            }
            if (this.form.averageRate == "") {
                this.$toast.error("Diligenciar el campo Tasa Promedio")
                return
            }
            if (this.form.internalRate == "") {
                this.$toast.error("Diligenciar el campo Tasa Interna")
                return
            }

            this.isLoading = true
            this.form.userId = this.$store.state.userId

            TasaCambio.createTasaCambio(this.form)
                .then((res) => {
                    this.$toast.success(res.data.message || "Tasa de cambio creada exitosamente")
                    this.$emit('clicked', false)
                })
                .catch((error) => {
                    console.error(error)
                    let errorMessage = this.$store.state._language == "es-ES" 
                        ? "Error al crear la tasa de cambio" 
                        : "Error creating exchange rate"
                    
                    if (error.response && error.response.data) {
                        if (error.response.data.message) {
                            errorMessage = error.response.data.message
                        }
                    }
                    
                    this.$toast.error(errorMessage)
                })
                .finally(() => {
                    this.isLoading = false
                })
        }
    },
    mounted() {
        Currency.getAllCurrency()
            .then((res) => {
                this.listCurrency = res.data.currency || []
            })
            .catch((error) => {
                console.error(error)
            })
    }
}
</script>

<style src="../main.css"></style>